import { render, staticRenderFns } from "./CarrierDetail.vue?vue&type=template&id=2130bb6e&scoped=true"
import script from "./CarrierDetail.vue?vue&type=script&lang=js"
export * from "./CarrierDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130bb6e",
  null
  
)

export default component.exports